import { render, staticRenderFns } from "./IconGauge.vue?vue&type=template&id=18814f94&"
import script from "./IconGauge.vue?vue&type=script&lang=js&"
export * from "./IconGauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports